import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgTimelinePause = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M6 19H10V5H6V19ZM14 5V19H18V5H14Z",
		fill: "currentColor"
	})
});
const ForwardRef = forwardRef(SvgTimelinePause);
export { ForwardRef as ReactComponent };
